import InputType from './InputType';

export default class TextInputType extends InputType {
  constructor({ placeholder, key, mask, validation, suggestionsId, filtered, minLength, numberMode, textareaMode, optional, onSuggestionSubmit, defaultData }) {
    super({ key });
    this.typeInput = 'text';
    this.mask = mask;
    this.placeholder = placeholder;
    this.validation = validation;
    this.suggestionsId = suggestionsId;
    this.filtered = filtered;
    this.minLength = minLength;
    this.numberMode = numberMode;
    this.textareaMode = textareaMode;
    this.optional = optional;
    this.onSuggestionSubmit = onSuggestionSubmit;
    this.defaultData = defaultData;
  }
}
